import { render, staticRenderFns } from "./biomini.vue?vue&type=template&id=2c57f9e0&scoped=true&"
import script from "./biomini.vue?vue&type=script&lang=js&"
export * from "./biomini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c57f9e0",
  null
  
)

export default component.exports